const CACHE_VERSION = 1;

function cacheKey(userId) {
  return `driver_portal_jobs_v${CACHE_VERSION}_${userId || 'anon'}`;
}

/**
 * @returns {{ jobs: object[], savedAt: string } | null}
 */
export function loadDriverJobsCache(userId) {
  try {
    const raw = localStorage.getItem(cacheKey(userId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || !Array.isArray(parsed.jobs)) return null;
    return {
      jobs: parsed.jobs,
      savedAt: parsed.savedAt || '',
    };
  } catch {
    return null;
  }
}

export function saveDriverJobsCache(userId, jobs) {
  try {
    localStorage.setItem(
      cacheKey(userId),
      JSON.stringify({
        savedAt: new Date().toISOString(),
        jobs: Array.isArray(jobs) ? jobs : [],
      })
    );
  } catch {
    /* quota / private mode */
  }
}

export function clearDriverJobsCache(userId) {
  try {
    localStorage.removeItem(cacheKey(userId));
  } catch {
    /* ignore */
  }
}
